module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-parking-lot-controller"
  }, [(_vm.parkingGroup) ? _c('div', {
    staticClass: "component-statistics-card statistics-card-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns small-6 large-4"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('span', [_vm._v("Parking Lot")]), _c('h3', [_vm._v("PL-" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.name))])])]), _c('div', {
    staticClass: "columns small-6 large-4"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('span', [_vm._v("Parking Group")]), _c('h3', [_vm._v("PG-" + _vm._s(_vm.parkingGroup.id) + " " + _vm._s(_vm.parkingGroup.name))])])]), _c('div', {
    staticClass: "columns small-6 large-4"
  }, [_c('div', {
    staticClass: "inner-content card"
  }, [_c('span', [_vm._v("Total Slots")]), _c('h3', [_vm._v(_vm._s(_vm.item.parking_slots.length))])])])])]) : _c('loading-spinner'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('router-tab-headers', {
    attrs: {
      "id": "vehicle-details",
      "tabs": _vm.tabs
    }
  }, [_c('router-view')], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a98bafe!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/controllers/ParkingLot.vue
// module id = 2566
// module chunks = 1